




















































































import { Vue, Component } from 'vue-property-decorator';
import {
  PartnerApi,
  FwUser,
  FwUserApi,
} from '@compassdigital/foodworks.api.ts';
import {
  PartnersApi, Partner, UserApi, User,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';
import UserModule from '@/store/modules/user';
import SystemModule from '@/store/modules/system';
import PartnerUtil from '@/util/PartnerUtil';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';
import SelectionDropdown from '@/components/Form/SelectionDropdown/index.vue';
import AdminInformation from '@/components/Form/Partner/FoodworksMarket/Edit/index.vue';
import ContactInformation from '@/components/Form/Partner/ContactInformationEdit/index.vue';
import RestaurantInformation from '@/components/Form/Partner/RestaurantInformation/Edit/index.vue';
import PartnerStatusIcon from '@/components/PartnerStatusIcon/index.vue';
import DeleteProfile from '@/components/Modal/DeleteProfile/index.vue';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
import AccountActivation from '@/components/AccountActivation/index.vue';
import PartnerModule from '@/store/modules/partner';
import Service from '@/util/ServiceUtil';
import {
  IRestPartnerInterface, IFwManagerInfo, IRestaurantUserInfo,
} from '@/interface/userTableInfo';
import Sidebar from '../sidebar.vue';

@Component({
  components: {
    Sidebar,
    SelectionDropdown,
    AdminInformation,
    ContactInformation,
    RestaurantInformation,
    PartnerStatusIcon,
    DeleteProfile,
    SecondaryButton,
    AccountActivation,
  },
})
export default class PartnerDetail extends Vue {
  public shouldStick: boolean = true;

  private errors: string = '';

  public partner: any = '';

  public markets: any = '';

  public partnerStatus: string = 'inactive';

  public userFormatted: any = null;

  public userStatus: string = '';

  public loading: boolean = false;

  public contactUser!: User | null;

  public scoutList: any = '';

  public loggedUser: any = '';

  public dialog: boolean = false;

  public dialogLoading: boolean = false;

  public activationLoader: boolean = false;

  public saving: boolean = false;

  public restarantPartnerInfo: IRestaurantUserInfo = {
    restPartnerEmail: '',
    is: '',
  };

  public scoutUserInfo: IFwManagerInfo = {
    scoutUserEmail: '',
    is: '',
  }

  public profileRest: IRestPartnerInterface = {
    deleteProfile: '',
    profileName: '',
    saving: false,
  }

  public mounted() {
    this.getPartnerByID();
  }

  public async getPartnerByID() {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { markets }: any = SystemModule;
          const items = MarketUtil.getMappedMarkets(markets);
          this.markets = Format.sortedArray(items);
          const { id } = this.$route.params;

          try {
            this.scoutList = await this.getScouts();
          } catch (error) {
            //
          }

          const api = new PartnersApi(AppModule.apiConfig);
          const partner: any = await api.getPartnerById(id);
          const { ownerUserId, scoutUserId } = partner.data;
          const userApi = new UserApi(AppModule.apiConfig);
          const userData = await userApi.getUser(ownerUserId);
          ((this.contactUser) as any) = userData.data;
          const { is }: any = userData.data;
          this.loggedUser = is.new;
          this.partner = PartnerUtil.getMappedPartner(
            partner.data, this.markets, this.scoutList,
          );
          const { restaurant: { name } } = this.partner;
          this.profileRest.profileName = name;
          PartnerModule.fetchRestaurantsProfile(id);
          const { onboarding } = partner.data;
          const partnerNewStatus = onboarding.status;
          this.getPartnerUserInfo(ownerUserId as string, scoutUserId as string);
          this.userFormatted = PartnerUtil.getPartnerStatusColor(partnerNewStatus as string);
          if (partnerNewStatus) {
            this.userStatus = partnerNewStatus;
          }
        } catch (err) {
          throw err;
        }
        if (this.partner.status === 'completed') {
          this.partnerStatus = this.partner.active ? 'active' : 'inactive';
        }
      }
    } catch (err) {
      console.log(err);
      if (err.error) {
        this.errors = err.error;
      }
    }
  }

  public async getPartnerUserInfo(partnerUserID: string, scoutUserID: string) {
    const userApi = new UserApi(AppModule.apiConfig);
    const users = await Promise.all(
      [(userApi.getUser(partnerUserID)), (userApi.getUser(scoutUserID))],
    );
    const userInfo = !users || users.map((response) => response.data);
    if (userInfo) {
      const partnerUser = userInfo[0];
      const scoutUser = userInfo[1];
      const { email, is } = partnerUser;
      this.restarantPartnerInfo.is = is;
      this.restarantPartnerInfo.restPartnerEmail = email as string;
      this.scoutUserInfo.scoutUserEmail = scoutUser.email as string;
      this.scoutUserInfo.is = scoutUser.is;
    }
    return null;
  }

  public async onUpdateStatus(status: string) {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { id } = this.$route.params;
          const state = status === 'active';
          const userState: any = {
            active: state,
          };
          if (this.userFormatted.status === 'Approved') {
            const api = new PartnersApi(AppModule.apiConfig);
            const partnerState: any = await api.patchPartnerById(id, userState);
            if (partnerState.status === 200) {
              ToastModule.setToast({
                message: `${partnerState.data.name} has been changed successfully`,
                timeout: 5000,
              });
            }
          }
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  get onBoardingPartnerID() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return '';
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  public async getScouts() {
    try {
      const api = new UserApi(AppModule.apiConfig);
      const users = await api.getUsers();
      return Format.usersListFormatted(users.data);
    } catch (err) {
      throw err;
    }
  }

  public get approverStatus() {
    const userStatus = Service.approverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }

  public openDialog() {
    this.dialog = true;
  }

  public closeDialog() {
    this.dialog = false;
    this.profileRest.deleteProfile = '';
  }

  public async onRestaurantProfileDelete() {
    try {
      this.profileRest.saving = true;
      const { id, restaurant: { name } } = this.partner;
      const api = new PartnersApi(AppModule.apiConfig);
      const user = await api.deletePartners(id as string);
      if (user.status === 200) {
        this.profileRest.deleteProfile = '';
        ToastModule.setToast({
          message: `${this.profileRest.profileName} has been deleted`,
          timeout: 5000,
        });
        this.$router.push('/partners');
      }
    } catch (err) {
      const { error } = err.response.data;
      ToastModule.setToast({
        message: error.message,
        timeout: 5000,
      });
    }
    this.profileRest.saving = false;
  }

  public async sendInvitation(userEmail: string, userProfile: string) {
    if (userProfile === 'restPartner') {
      this.activationLoader = true;
    }
    if (userProfile === 'fwmanager') {
      this.saving = true;
    }
    const user: any = await Service.sendInvitation(userEmail);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      ToastModule.setToast({
        message: user.errorMessage,
        timeout: 5000,
      });
    }
    if (userProfile === 'restPartner') {
      this.activationLoader = false;
    }
    this.saving = false;
  }
}
